import { render, staticRenderFns } from "./BlocoCulturaMonitoramentoAgricola.vue?vue&type=template&id=2d865c08&scoped=true&lang=pug"
import script from "./BlocoCulturaMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./BlocoCulturaMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./BlocoCulturaMonitoramentoAgricola.vue?vue&type=style&index=0&id=2d865c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d865c08",
  null
  
)

export default component.exports